<template>
  <button class="icon-btn" :class="variant && `icon-btn--${variant}`" v-bind="$attrs">
    <slot />
  </button>
</template>

<script>
  export default {
    name: 'IconBtn',
    props: ['variant'],
    inheritAttrs: true
  }
</script>

<style scoped>
.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  color: rgba(0, 0, 0, 0.3);
  transition: color 0.12s, background 0.12s;
  flex-shrink: 0;
}

.icon-btn :deep(svg) {
  width: 14px;
  height: 14px;
  display: block;
}

.icon-btn:hover {
  color: rgba(0, 0, 0, 0.65);
  background: rgba(0, 0, 0, 0.06);
}

.icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.icon-btn--danger:hover {
  color: #b03a3a;
  background: rgba(190, 60, 60, 0.08);
}

.icon-btn--active,
.icon-btn--active:hover {
  color: var(--primary);
  background: var(--primary-muted);
}

.icon-btn--timer-on,
.icon-btn--timer-on:hover {
  color: #2e7d45;
  background: rgba(61, 144, 80, 0.1);
}
</style>
